import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider, PickersDay } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getPlanDates } from "api/dietPlan";
import { CircularProgress, Box, styled } from "@mui/material";
import "dayjs/locale/nl"; // 1. MUST IMPORT THE LOCALE DATA
import { nlNL } from "@mui/x-date-pickers/locales";
import { useUserData } from "@context/OAuth/AuthContext";

function MuiDatePickerInput({ fetchDietPlan, dates, isLoading }) {
  const [open, setOpen] = useState(false);
  const [apiAvailableDates, setApiAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const { language } = useUserData();

  useEffect(() => {
    const fetchAvailable = async () => {
      try {
        const response = await getPlanDates();
        setApiAvailableDates(response || []);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchAvailable();
  }, []);

  const currentPlanDates = dates?.map((item) => item.fullDate) || [];
  const todayStr = dayjs().format("YYYY-MM-DD");

  const getDateRangeDisplay = () => {
    if (!dates || !dates.length) return "DD/MM/YYYY";
    const firstDate = dayjs(dates[0].fullDate).format("DD/MM/YYYY");
    const lastDate = dayjs(dates[dates.length - 1].fullDate).format(
      "DD/MM/YYYY",
    );
    return dates.length === 1 ? firstDate : `${firstDate} - ${lastDate}`;
  };

  const shouldDisableDate = (date) => {
    if (!apiAvailableDates.length) return false;
    return !apiAvailableDates.includes(dayjs(date).format("YYYY-MM-DD"));
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={language}
      localeText={
        language === "nl"
          ? nlNL.components.MuiLocalizationProvider.defaultProps.localeText
          : undefined
      }
    >
      <DatePicker
        format="DD/MM/YYYY"
        label={getDateRangeDisplay()}
        value={selectedDate}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => !isLoading && setOpen(false)}
        onChange={(newDate) => {
          setSelectedDate(newDate);
          fetchDietPlan(newDate);
        }}
        shouldDisableDate={shouldDisableDate}
        disabled={isLoading}
        slotProps={{
          toolbar: { hidden: true },
          textField: {
            onClick: () => !isLoading && setOpen(true),
            placeholder: getDateRangeDisplay(),
            sx: {
              "& .MuiInputBase-root": {
                cursor: isLoading ? "not-allowed" : "pointer",
              },
            },
            InputProps: {
              endAdornment: isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              ) : undefined,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default MuiDatePickerInput;
